export const DEPLOY_ENV = window.AR_DEPLOY_ENV;
export const API_URL = window.AR_API_URL;
export const LOGIN_URL = window.AR_LOGIN_URL;
export const PUBLIC_URL = window.AR_PUBLIC_URL;
export const MAIN_SITE_HOMEPAGE = window.AR_MAIN_SITE_HOMEPAGE;
export const AR_ATENA_DOMAIN = window.AR_ATENA_DOMAIN;
export const UTAG_SYNC_URL = window.AR_UTAG_SYNC_URL;
export const UTAG_ASYNC_URL = window.AR_UTAG_ASYNC_URL;
export const BUYAPOWA_SISAL_LINK = window.AR_BUYAPOWA_SISAL_LINK;
export const BUYAPOWA_MARKET = window.AR_BUYAPOWA_MARKET;
export const BUYAPOWA_SLUG = window.AR_BUYAPOWA_SLUG;
export const CMS_API_URL = window.AR_CMS_API_URL;
export const HORSE_RACING_URL = window.AR_HORSE_RACING_URL;
export const SISAL_STAGING_MSTCHANNEL_URL =
  window.AR_SISAL_STAGING_MSTCHANNEL_URL;
export const GNTNPLAY_HORSE_RACING_URL = window.AR_GNTNPLAY_HORSE_RACING_URL;
export const GNTNPLAY_TYCHE_URL = window.AR_GNTNPLAY_TYCHE_URL;
export const NVE = window.AR_NVE;
export const NVE_MOBILE = window.AR_NVE_MOBILE;
export const LOTTERY_ITALY_URL = window.AR_LOTTERY_ITALY_URL;
export const SCRATCH_AND_WIN_LIB = window.AR_SCRATCH_AND_WIN_LIB;
export const IPPICA_MST_CID = window.AR_IPPICA_MST_CID;
export const GTN_PLAY_PDV = window.AR_GTN_PLAY_PDV;
export const LOTTO_TICKET_URL = window.AR_LOTTO_TICKET_URL;
export const PLAY_YOUR_DATE = window.AR_PLAY_YOUR_DATE;
export const SUBSCRIPTIONS_ENABLED = window.AR_SUBSCRIPTIONS_ENABLED;
export const APP_VENDOR = window.AR_APP_VENDOR ?? 'pokerstars';
export const APP_COUNTRY = window.AR_APP_COUNTRY ?? 'es';
export const GNTN_HOST = window.AR_GNTN_HOST;
export const GNTN_CONFIGURATION_URL = window.AR_GNTN_CONFIGURATION_URL;
export const SSO_REFRESH_BASIC_AUTH = window.AR_SSO_REFRESH_BASIC_AUTH;
export const SANDSIV_ENABLED = window.AR_SANDSIV_ENABLED ?? false;
export const AR_PRIVACY_POLICY_URL = window.AR_PRIVACY_POLICY_URL;
export const AR_CONTRACT_URL = window.AR_CONTRACT_URL;
export const AR_SESSION_TIME_DOMAIN = window.AR_SESSION_TIME_DOMAIN;
export const ONETRUST_ID = window.AR_ONETRUST_ID;
export const CONTRACT_URL = window.AR_CONTRACT_URL;
export const PRIVACY_POLICY_URL = window.AR_PRIVACY_POLICY_URL;
export const VIEW_BONUS_BALANCE_ENABLED =
  window.AR_VIEW_BONUS_BALANCE_ENABLED ?? false;
